import React from 'react';
import { Breakpoint } from '@moda/om';
import { LineItem } from '../../hooks/useCart/cart.rest';
import { LineItemMiniGranularity } from '../LineItem/LineItemMini';
import { LineItemListFull } from './LineItemListFull';
import { LineItemListMini } from './LineItemListMini';

type Props = {
  size?: 'mini' | 'full';
  theme?: 'box' | 'simple';
  title?: string;
  items: LineItem[];
  showPriceWithVAT?: boolean;
};

export const LineItemList: React.FC<Props> = ({
  size = 'full',
  theme,
  title,
  items,
  showPriceWithVAT
}) => {
  if (size === 'mini')
    return (
      <LineItemListMini
        granularity={LineItemMiniGranularity.Minimal}
        title={title}
        theme={theme}
        items={items}
        showPriceWithVAT={showPriceWithVAT}
      />
    );

  return (
    <>
      <Breakpoint lt="md">
        <LineItemListMini
          showPriceWithVAT={showPriceWithVAT}
          title={title}
          theme={theme}
          items={items}
        />
      </Breakpoint>
      <Breakpoint gt="md">
        <LineItemListFull
          showPriceWithVAT={showPriceWithVAT}
          title={title}
          theme={theme}
          items={items}
        />
      </Breakpoint>
    </>
  );
};
